import { CustomerCombinedAsset, CustomerCombinedAssetCounts } from '../../store/CustomerCombinedAsset';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getCustomerCombinedAssetCounts = (customerId: string, supplierId?: string) => {
  let url = `${API_SERVER_URL}/customer-combined-assets/${customerId}/counts`;
  if (supplierId) url += `?supplier_id=${supplierId}`;
  return apiService.callExternalApi<CustomerCombinedAssetCounts>({
    url,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const listCustomerCombinedAssets = (customerId: string, filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 25,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'assetNumber', direction: 'desc' }]
  };
  return apiService.callExternalApi<PaginatedResponse<CustomerCombinedAsset>>({
    url: buildAdvancedQueryURL(mergedFilters, `customer-combined-assets/${customerId}`),
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};
